const jquery = require("jquery");

var $ = jQuery.noConflict();

function offersFilter(retailers, ranges) {
    $('#team-results').empty();

    $('#loading').addClass('active');
    $('#load-more').addClass('hide');
    $('#load-more').attr('data-retailers', retailers);
    $('#load-more').attr('data-ranges', ranges);
    $('#load-more').attr('data-page', 1);

    var animPromise, result, total;
    ajaxPromise = $.ajax({
        type: 'POST',
        url: sealy_ajax_object.ajax_url,
        dataType: 'json',
        data: ({
            'action': 'filter_offers',
            'retailers': retailers,
            'ranges': ranges,
        }),
        success: function (data) {
            result = data.html;  
            total = data.total;
        }
    });
    $.when(animPromise, ajaxPromise).done(function () {
        $('#offer-results').html(result);
        $('#offer-results').attr('data-total', total);
        $('#loading').removeClass('active');
        reviewLoadmore();
    });
} 

function reviewLoadmore(){
    var total = $('#offer-results').attr('data-total');
    var numitems = $('#offer-results .offer-item').length; 
  
    if(total > numitems){
      $('#load-more').removeClass('hide'); 
    } else {
      $('#load-more').addClass('hide'); 
    }
}

$(window).on('load', function () {

    var filter_active = false;

    $('body').on('change', '.block-offer-listing-filters-toggle', function(){
        if( $('.block-offer-listing-filters-toggle:checked').length ){
            filter_active = true;
        }else{
            filter_active = false;
        }

        if( filter_active ){
            $('#clear-filters').addClass('active');
        }else{
            $('#clear-filters').removeClass('active');
        }

        var retailers = [];
        $('input[name=retailer]:checked').each(function(){
            if( $(this).val() ){
                retailers.push( $(this).val() );
            }
        });

        var ranges = [];
        $('input[name=range]:checked').each(function(){
            if( $(this).val() ){
                ranges.push( $(this).val() );
            }
        });

        offersFilter(retailers, ranges);
    });


    $(document).on("click", '.block-offer-listing #load-more', function(e) { 
        var page_num =  parseInt($('#load-more').attr('data-page'));
        page_num++;
        var retailers = $(this).attr('data-retailers').split(',');
        var ranges = $(this).attr('data-ranges').split(',');

    
        $('#loading').addClass('active');
        $('#load-more').addClass('hide'); 
    
        var animPromise, result;
        ajaxPromise = $.ajax({
            type: 'POST',
            url: sealy_ajax_object.ajax_url,
            dataType: 'json',
            data: ({
                'action': 'filter_offers',
                'retailers': retailers,
                'ranges': ranges,
                'paged': page_num 
            }),
            success: function (data) {
                result = data.html; 
            }
        });
        $.when(animPromise, ajaxPromise).done(function () {
            $('#offer-results').append(result);
            $('#loading').removeClass('active'); 
            $('#load-more').attr('data-page', page_num);
            reviewLoadmore();
        });
    });

    $(document).on("click", '.block-offer-listing #clear-filters', function(e) { 
        e.preventDefault();
        
        $('.block-offer-listing .block-offer-listing-filters-toggle').prop('checked', false); 
        $('.block-offer-listing .block-offer-listing-filters-toggle').trigger('change');
    });
});